import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createActions, createFullSelector } from '../store';
var withReduxActions = function (gridName, prefix) {
    if (prefix === void 0) { prefix = 'grid'; }
    var actions = createActions(gridName);
    var selectors = createFullSelector(gridName);
    return connect(function (state) {
        var _a;
        return (_a = {},
            _a["".concat(prefix, "Selectors")] = selectors(state),
            _a);
    }, function (dispatch) {
        var _a;
        return (_a = {},
            _a["".concat(prefix, "Actions")] = bindActionCreators({
                init: actions.init,
                clearUxState: actions.clearUxState,
                handleUxChange: actions.handleUxChange,
                openConfigForm: actions.openConfigForm,
                closeConfigForm: actions.closeConfigForm,
                setColumnConfig: actions.setColumnConfig,
                setPage: actions.setPage,
                setPresets: actions.setPresets,
                createPreset: actions.createPreset,
                deletePreset: actions.deletePreset,
                setRowsPerPage: actions.setRowsPerPage,
                addFilter: actions.addFilter,
                setFilters: actions.setFilters,
                resetFilters: actions.resetFilters,
                addSorting: actions.addSorting,
                clearSettings: actions.clearSettings,
                setColumnWidth: actions.setColumnWidth,
                resetGrid: actions.resetGrid,
                setColumnsOrder: actions.setColumnsOrder,
            }, dispatch),
            _a);
    });
};
export default withReduxActions;
